/**
 * Tracking Scripts Manager
 *
 * This file contains functions to enable various tracking and analytics services
 * after user consent has been granted via the Plume Cookie Banner.
 *
 * All functions check for appropriate consent before initializing their respective services.
 */

import { getMetaValue } from '../utils'

// Helper function to check if consent has been granted for a category
function hasConsent(category) {
  if (window.PlumeCookies && window.PlumeCookies.hasConsent()) {
    const preferences = window.PlumeCookies.getPreferences()
    return preferences && preferences[category] === true
  }
  return false
}

export function enableGoogleAnalytics() {
  // Only enable if analytics consent is granted
  if (!hasConsent('analytics')) {
    console.debug('Google Analytics not enabled: no analytics consent')
    return
  }

  const shouldEnableGoogleAnalytics = getMetaValue('google_analytics')
  if (!shouldEnableGoogleAnalytics) return

  const google_analytics_id = getMetaValue('google_analytics_id')

  var el = document.createElement('script')
  el.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${google_analytics_id}`)
  el.setAttribute('async', true)

  if (document.head !== null) {
    document.head.appendChild(el)
  }

  gtag('js', new Date())
  gtag('config', google_analytics_id, {
    page_title: document.title,
    page_path: location.href.replace(location.origin, '')
  })

  // Turbo version
  document.addEventListener('turbo:load', () => {
    // Google Analytics.
    // https://github.com/turbolinks/turbolinks/issues/73#issuecomment-460028854
    if (typeof gtag == 'function') {
      gtag('config', google_analytics_id, {
        page_title: document.title,
        page_path: location.href.replace(location.origin, '')
      })
    }
  })
}

export function enableHotjar() {
  // Only enable if analytics consent is granted
  if (!hasConsent('analytics')) {
    console.debug('Hotjar not enabled: no analytics consent')
    return
  }

  const shouldEnableHotjar = getMetaValue('hotjar')
  if (!shouldEnableHotjar) return

  function hotjar(h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        ;(h.hj.q = h.hj.q || []).push(arguments)
      }
    h._hjSettings = { hjid: 2053389, hjsv: 6 }
    a = o.getElementsByTagName('head')[0]
    r = o.createElement('script')
    r.async = 1
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
    a.appendChild(r)
  }

  // activate
  hotjar(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')
}

export function enableFacebookPixel() {
  // Only enable if marketing consent is granted
  if (!hasConsent('marketing')) {
    console.debug('Facebook Pixel not enabled: no marketing consent')
    return
  }

  const shouldEnableFacebookPixel = getMetaValue('facebook_pixel')
  if (!shouldEnableFacebookPixel) return

  function pixel(f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  }
  // add the tag element
  pixel(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')

  // activate
  const facebookPixelId = getMetaValue('facebook_pixel_id')
  fbq('init', facebookPixelId)
  fbq('track', 'PageView')
}

export function enableWisepops() {
  // Only enable if marketing consent is granted
  if (!hasConsent('marketing')) {
    console.debug('Wisepops not enabled: no marketing consent')
    return
  }

  const shouldWisepops = getMetaValue('wisepops')
  if (!shouldWisepops) return
  console.log('wp')

  function wisepops(W, i, s, e, P, o, p) {
    W['WisePopsObject'] = P
    ;((W[P] =
      W[P] ||
      function () {
        ;(W[P].q = W[P].q || []).push(arguments)
      }),
      (W[P].l = 1 * new Date()))
    ;((o = i.createElement(s)), (p = i.getElementsByTagName(s)[0]))
    o.defer = 1
    o.src = e
    p.parentNode.insertBefore(o, p)
  }

  //activate
  const wisepopsId = getMetaValue('wisepops_id')

  wisepops(
    window,
    document,
    'script',
    `//loader.wisepops.com/get-loader.js?v=1&site=${wisepopsId}`,
    'wisepops'
  )
}
